/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetAddiServByWareBillTypeRespVo } from './GetAddiServByWareBillTypeRespVo';
import {
    GetAddiServByWareBillTypeRespVoFromJSON,
    GetAddiServByWareBillTypeRespVoFromJSONTyped,
    GetAddiServByWareBillTypeRespVoToJSON,
    GetAddiServByWareBillTypeRespVoToJSONTyped,
} from './GetAddiServByWareBillTypeRespVo';

/**
 * 
 * @export
 * @interface ResponseListGetAddiServByWareBillTypeRespVo
 */
export interface ResponseListGetAddiServByWareBillTypeRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListGetAddiServByWareBillTypeRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListGetAddiServByWareBillTypeRespVo
     */
    message?: string;
    /**
     * 
     * @type {Array<GetAddiServByWareBillTypeRespVo>}
     * @memberof ResponseListGetAddiServByWareBillTypeRespVo
     */
    data?: Array<GetAddiServByWareBillTypeRespVo>;
}

/**
 * Check if a given object implements the ResponseListGetAddiServByWareBillTypeRespVo interface.
 */
export function instanceOfResponseListGetAddiServByWareBillTypeRespVo(value: object): value is ResponseListGetAddiServByWareBillTypeRespVo {
    return true;
}

export function ResponseListGetAddiServByWareBillTypeRespVoFromJSON(json: any): ResponseListGetAddiServByWareBillTypeRespVo {
    return ResponseListGetAddiServByWareBillTypeRespVoFromJSONTyped(json, false);
}

export function ResponseListGetAddiServByWareBillTypeRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListGetAddiServByWareBillTypeRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(GetAddiServByWareBillTypeRespVoFromJSON)),
    };
}

export function ResponseListGetAddiServByWareBillTypeRespVoToJSON(json: any): ResponseListGetAddiServByWareBillTypeRespVo {
    return ResponseListGetAddiServByWareBillTypeRespVoToJSONTyped(json, false);
}

export function ResponseListGetAddiServByWareBillTypeRespVoToJSONTyped(value?: ResponseListGetAddiServByWareBillTypeRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(GetAddiServByWareBillTypeRespVoToJSON)),
    };
}

